export default "__VITE_ASSET__Da1O68g___"